import { render, staticRenderFns } from "./fkchuqi.vue?vue&type=template&id=6a8a6684"
import script from "./fkchuqi.vue?vue&type=script&lang=js"
export * from "./fkchuqi.vue?vue&type=script&lang=js"
import style0 from "./fkchuqi.vue?vue&type=style&index=0&id=6a8a6684&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports